import { GetItemLinkProps } from '../../types';

let pageNumber: number | undefined;

const isDev = process.env.TS_ENV !== 'prod';

const getItemLink = ({ page, target, link }: GetItemLinkProps) => {
  const commonParams = {
    ...(isDev && { env: 'prod' }),
    ...link.params
  };

  const route = link.route;

  switch (true) {
    case target === 'current':
      pageNumber = page !== 1 ? page : undefined;

      return {
        route,
        params: {
          ...commonParams,
          ...(pageNumber && { pageNumber })
        }
      };
    case target === 'prev':
      pageNumber = page - 1;

      return {
        route,
        params: {
          ...commonParams,
          pageNumber
        }
      };
    case target === 'next':
      pageNumber = page + 1;

      return {
        route,
        params: {
          ...commonParams,
          pageNumber
        }
      };
    default:
      return {
        route,
        params: {
          ...commonParams,
          pageNumber: `${page}`
        }
      };
  }
};

export default getItemLink;
